import { Route } from 'react-router-dom';

import HomeView from './containers/HomeView';
import RegistrationView from './containers/RegistrationView';
import LoginView from './containers/LoginView';
import LoginRequiredView from './containers/LoginRequiredView';
import LikesView from './containers/LikesView';
import AppliedView from './containers/AppliedView';
import ProfileView from './containers/ProfileView';
import JobsViewV2 from './containers/Jobs/JobsViewV2';
import JobApplicationsView from './containers/JobApplications/JobApplicationsView';
import JobsDetailedView from './containers/Jobs/JobsDetailedView';
import ServiceProvidersListView from './containers/ServiceProviders/ServiceProvidersListView';
import RecruitmentAgenciesListView from './containers/RecruitmentAgencies/RecruitmentAgenciesListView';
import EmployersListView from './containers/Employers/EmployersListView';
import GuidesView from './containers/Guides/GuidesView';
import NewsView from './containers/News/NewsView';
import NotificationsView from './containers/Notifications';
import PollsListViewV2 from './containers/Polls/PollsListViewV2';
import ScreeningView from './containers/Jobs/Screening/ScreeningView';
import SurveysDetailedView from './containers/Surveys/SurveysDetailedView';
import SurveysListView from './containers/Surveys/SurveysListView';

import GuidesDetailedView from './containers/Guides/GuidesDetailedView';
import NewsDetailedView from './containers/News/NewsDetailedView';
import ServiceProvidersDetailedView from './containers/ServiceProviders/ServiceProvidersDetailedView';
import RecruitmentAgenciesDetailedView from './containers/RecruitmentAgencies/RecruitmentAgenciesDetailedView';
import EmployersDetailedViewV2 from './containers/Employers/EmployersDetailedViewV2';
import ChooseLanguageView from './containers/ChooseLanguageView';
import ProblemsView from './containers/Problems/ProblemsView';
import DetailedProblemView from './containers/Problems/DetailedProblemView';
import JobseekersResumeView from './containers/Jobseekers/JobseekersResumeView';
import JobseekersEditResumeView from './containers/Jobseekers/JobseekersEditResumeView';
import JobseekersDetailedResumeView from './containers/Jobseekers/JobseekersDetailedResumeView';
import PrivacyPolicyView from './containers/StaticPages/PrivacyPolicyView';
import ChildProtectionPolicyView from './containers/StaticPages/ChildProtectionPolicyView';
import MemberAgreementView from './containers/StaticPages/MemberAgreementView';

import NotFoundView from './containers/NotFoundView';

import MarketPlaceHomeView from './containers/MarketPlace/MarketPlaceHomeView';
import FilteredJobsByEmployerView from './containers/Jobs/FilteredJobsByEmployerView';
import RecruiterRosterView from './containers/RecruitmentAgencies/RecruiterRosterView';
import RecruiterRosterDetailedView from './containers/RecruitmentAgencies/RecruiterRosterDetailedView';
import PostListView from './containers/Forum/PostListView';
import PostDetailedView from './containers/Forum/PostDetailedView';
import 'react-lazy-load-image-component/src/effects/blur.css';
import ForgotPasswordView from './containers/PasswordReset/ForgotPasswordView';
import ResetPasswordForm from './containers/PasswordReset/ResetPasswordForm';
import EmployerRosterView from './containers/Employers/EmployerRosterView';
import EmployerRosterDetailedView from './containers/Employers/EmployerRosterDetailedView';

import PrivateRoute from './components/routes/PrivateRoute';
import GuestRoute from './components/routes/GuestRoute';

export const routes = [
  {
    type: Route,
    exact: true,
    path: '/',
    component: HomeView
  },
  {
    type: Route,
    exact: true,
    path: '/jobs',
    component: JobsViewV2
  },
  {
    type: Route,
    exact: true,
    path: '/jobs/employer/:id',
    component: FilteredJobsByEmployerView
  },
  {
    type: Route,
    exact: true,
    path: '/jobs/:id',
    component: JobsDetailedView
  },
  {
    type: Route,
    exact: true,
    path: '/jobs/:jobId/screening',
    component: ScreeningView
  },
  {
    type: Route,
    exact: true,
    path: '/job-applications',
    component: JobApplicationsView
  },
  {
    type: Route,
    exact: true,
    path: '/services',
    component: ServiceProvidersListView
  },
  {
    type: Route,
    exact: true,
    path: '/services/:id',
    component: ServiceProvidersDetailedView
  },
  {
    type: Route,
    exact: true,
    path: '/guides',
    component: GuidesView
  },
  {
    type: Route,
    exact: true,
    path: '/guides/:id',
    component: GuidesDetailedView
  },
  {
    type: Route,
    exact: true,
    path: '/news',
    component: NewsView
  },
  {
    type: Route,
    exact: true,
    path: '/news/:id',
    component: NewsDetailedView
  },
  {
    type: Route,
    exact: true,
    path: '/marketplace',
    component: MarketPlaceHomeView
  },
  {
    type: Route,
    exact: true,
    path: '/recruitment-agencies',
    component: RecruitmentAgenciesListView
  },
  {
    type: Route,
    exact: true,
    path: '/recruitment-agencies/:id',
    component: RecruitmentAgenciesDetailedView
  },
  {
    type: Route,
    exact: true,
    path: '/recruiter-roster',
    component: RecruiterRosterView
  },
  {
    type: Route,
    exact: true,
    path: '/recruiter-roster/:recruiter_id',
    component: RecruiterRosterDetailedView
  },
  {
    type: Route,
    exact: true,
    path: '/employer-roster',
    component: EmployerRosterView
  },
  {
    type: Route,
    exact: true,
    path: '/employer-roster/:employer_id',
    component: EmployerRosterDetailedView
  },
  {
    type: Route,
    exact: true,
    path: '/employers',
    component: EmployersListView
  },
  {
    type: Route,
    exact: true,
    path: '/employers/:id',
    component: EmployersDetailedViewV2
  },
  {
    type: Route,
    exact: true,
    path: '/polls',
    component: PollsListViewV2
  },
  {
    type: Route,
    exact: true,
    path: '/change-language',
    component: ChooseLanguageView
  },
  {
    type: Route,
    exact: true,
    path: '/member-agreement',
    component: MemberAgreementView
  },
  {
    type: Route,
    exact: true,
    path: '/problems',
    component: ProblemsView
  },
  {
    type: Route,
    exact: true,
    path: '/problems/:id',
    component: DetailedProblemView
  },
  {
    type: Route,
    exact: true,
    path: '/privacy-policy',
    component: PrivacyPolicyView
  },
  {
    type: Route,
    exact: true,
    path: '/child-protection-policy',
    component: ChildProtectionPolicyView
  },
  { type: GuestRoute, path: '/registration', component: RegistrationView },
  {
    type: GuestRoute,
    exact: true,
    path: '/login',
    component: LoginView
  },
  {
    type: GuestRoute,
    exact: true,
    path: '/login-required',
    component: LoginRequiredView
  },
  {
    type: PrivateRoute,
    exact: true,
    path: '/notifications',
    component: NotificationsView
  },
  {
    type: PrivateRoute,
    exact: true,
    path: '/applied',
    component: AppliedView
  },
  {
    type: PrivateRoute,
    exact: true,
    path: '/like',
    component: LikesView
  },
  {
    type: PrivateRoute,
    exact: true,
    path: '/resume',
    component: JobseekersResumeView
  },
  {
    type: PrivateRoute,
    exact: true,
    path: '/resume-edit',
    component: JobseekersEditResumeView
  },
  {
    type: PrivateRoute,
    exact: true,
    path: '/resume-view',
    component: JobseekersDetailedResumeView
  },
  {
    type: Route,
    exact: true,
    path: '/surveys',
    component: SurveysListView
  },
  {
    type: Route,
    exact: true,
    path: '/surveys/:identifier',
    component: SurveysDetailedView
  },
  {
    type: Route,
    exact: true,
    path: '/forgot-password',
    component: ForgotPasswordView
  },
  {
    type: Route,
    exact: true,
    path: '/api/v2/reset-password/*',
    component: ResetPasswordForm
  },
  {
    type: Route,
    exact: true,
    path: '/groups',
    component: PostListView
  },
  {
    type: Route,
    exact: true,
    path: '/groups/:id/:langId',
    component: PostDetailedView
  },
  {
    type: PrivateRoute,
    exact: true,
    path: '/profile',
    component: ProfileView
  },
  { type: Route, path: '*', component: NotFoundView }
];

export default routes;
